import { render, staticRenderFns } from "./scrollType.vue?vue&type=template&id=046441aa&scoped=true"
import script from "./scrollType.vue?vue&type=script&lang=js"
export * from "./scrollType.vue?vue&type=script&lang=js"
import style0 from "./scrollType.vue?vue&type=style&index=0&id=046441aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046441aa",
  null
  
)

export default component.exports